import React, { Component } from "react";
import "./tela_video.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentAlt,
  faArrowCircleRight,
  faClock
} from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import ListaMensagens from "../chat/lista_mensagens";
import GridButtons from "./grid_buttons";
import { InputChatVideo } from "../chat/input_chat";
import { Link } from "react-router-dom";
//import firebase from '../../firebase/setup';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Button } from "reactstrap";
import {
  finalizeVideochat,
  cancelVideochat,
  activateVideochat
} from "../../providers/videochatProvider";
import { socket } from "../../providers/config";
import { updateConsultStatus } from "../../providers/chatProvider";

const mediaStreamConstraints = {
  video: true,
  audio: true
};

//const servers = {'iceServers': [{'urls': 'stun:stun.services.mozilla.com'}, {'urls': 'stun:stun.l.google.com:19302'}]};

class TelaVideo extends Component {
  constructor() {
    super();
    this.state = {
      chatAberto: false,
      mute: false,
      professional: "",
      customer: "",
      status: "",
      expiredModalOpen: false,
      callString: "Iniciar chamada"
    };
    this.alteraChat = this.alteraChat.bind(this);
    this.remoteVideoRef = null;
    this.localVideoRef = null;
    this.localStream = null;
    this.pc = null;
    this.hasFinished = false;
  }

  componentDidMount() {
    //console.log(this.props.match.params.chatId);
    updateConsultStatus(
      this.props.match.params.chatId,
      "waiting",
      this.props.token
    );

    this.subscribeToVideoChat();
    this.pc = new RTCPeerConnection();
    this.pc.onicecandidate = event => {
      if (event.candidate) {
        //send message to firestore
        //console.log(event.candidate);

        this.sendMessage({ ice: event.candidate });
      }
    };
    this.pc.ontrack = trackEvent => {
      this.remoteVideoRef.srcObject = trackEvent.streams[0];
      //sending begin time
      console.log("begin time");
    };
    //this.pc.onconnectionstatechange = event => console.log('connection state change',event);
    this.pc.oniceconnectionstatechange = this.handleConnectionStateChange;
    //this.pc.onicegatheringstatechange = event => console.log('ice gathering state',this.pc.iceGatheringState)
    this.start();
  }

  componentWillUnmount() {
    this.onTerminateChat();
    this.unsubscribe();
  }

  handleConnectionStateChange = event => {
    switch (this.pc.iceConnectionState) {
      case "failed":
        console.log("failed");
        break;
      case "disconnected":
        console.log("disconnected");
        break;
      case "connected":
        console.log("connected");
        if (
          this.state.status === "requested" ||
          (this.state.status === "waiting" &&
            this.props.userId === this.state.customer._id)
        )
          activateVideochat(this.props.match.params.chatId, this.props.token);
        break;
      case "closed":
        console.log("closed");
        break;
    }
  };

  onTerminateChat = (creditsExpired = false) => {
    if (this.hasFinished) return;
    this.closeVideoCall();
    //mark video_chat as finished on firestore
    if (this.state.status === "active")
      finalizeVideochat(this.props.match.params.chatId, this.props.token);
    if (this.state.status === "requested" || this.state.status === "waiting")
      //cancelling request
      cancelVideochat(this.props.match.params.chatId, this.props.token);

    this.hasFinished = true;
  };

  closeVideoCall = () => {
    if (this.pc) {
      this.pc.ontrack = null;
      this.pc.onicecandidate = null;
      if (this.remoteVideoRef.srcObject) {
        this.remoteVideoRef.srcObject
          .getTracks()
          .forEach(track => track.stop());
      }
      if (this.localVideoRef.srcObject) {
        this.localVideoRef.srcObject.getTracks().forEach(track => track.stop());
      }
      this.pc.close();
      this.pc = null;
    }
    this.remoteVideoRef.removeAttribute("srcObject");
    this.localVideoRef.removeAttribute("srcObject");
  };

  unsubscribe = () => {
    socket.emit("unsubscribe_to_video", {
      consultId: this.props.match.params.chatId
    });
    socket.off("update_video_status");
    socket.off("new_video_message");
  };

  subscribeToVideoChat = () => {
    socket.emit("subscribe_to_video", {
      consultId: this.props.match.params.chatId
    });
    socket.on("update_video_status", consult => {
      console.log("update_video_status");
      console.log(consult);

      if (this.state.status !== consult.status) {
        //console.log("*** RECEIVE NEW STATUS ***", consult.status);

        this.setState({ status: consult.status });
      }
      if (!this.state.professional) {
        console.log("Setting professional and customer on the state");
        console.log(consult.professionalId);

        this.setState({
          professional: consult.professionalId,
          customer: consult.customerId
        });
      }
    });
    socket.on("new_video_message", message => {
      console.log("new_video_message");

      this.readMessage(message);
    });
    /* this.unsubscribe = firebase.firestore().doc(`video_chats/${this.props.match.params.chatId}`)
        .onSnapshot(doc => {
            const data = doc.data();
            //console.log(data);
            
            if(this.state.status !== data.status) {
                if(data.credits_expired && data.customer === this.props.auth.uid && data.status === 'finished'){
                    this.setState({expiredModalOpen: true,status: data.status});
                    return;
                }
                this.setState({status: data.status});
                this.initTimeout(data);
            }
            if(!this.state.professional)
                this.setState({professional:data.professional, customer:data.customer});
            this.readMessage(data.message);
        }); */
  };

  initTimeout = data => {
    /* if(data.customer !== this.props.auth.uid) return;
        if(data.status !== 'active') return;
        console.log('*** initTimeout ***');
        const expiringTime = data.max_available_minutes * 60 * 1000;
        setTimeout(() => this.onTerminateChat(true), expiringTime); */
  };

  readMessage = message => {
    //console.log(message);

    if (!message) return;
    if (!message.data) return;
    if (message.senderId === this.props.userId) return;
    const data = JSON.parse(message.data);
    //console.log(data);
    if (data.ice != undefined) {
      const candidate = new RTCIceCandidate(data.ice);
      //console.log(candidate);
      this.pc
        .addIceCandidate(candidate)
        .then(result => console.log(result))
        .catch(error => {
          console.error("ADD ICE CANDIDATE ERROR", error);
          this.setState({ callString: "Tente novamente" });
        });
    } else if (data.sdp.type == "offer") {
      //console.log("offer");
      this.pc
        .setRemoteDescription(new RTCSessionDescription(data.sdp))
        .then(() => this.pc.createAnswer())
        .then(answer => this.pc.setLocalDescription(answer))
        .then(() => this.sendMessage({ sdp: this.pc.localDescription }))
        .catch(error => console.log("OFFER REMOTE DESCRIPTION ERROR", error));
    } else if (data.sdp.type == "answer") {
      //console.log("answer");
      this.pc
        .setRemoteDescription(new RTCSessionDescription(data.sdp))
        .catch(error =>
          console.error("ANSWER REMOTE DESCRIPTION ERROR", error)
        );
      //if(this.state.status === 'requested')
      // activateVideochat(this.props.match.params.chatId);
    }
  };

  sendMessage = data => {
    //console.log("Sending message...");
    const message = {
      consultId: this.props.match.params.chatId,
      message: {
        senderId: this.props.userId,
        data: JSON.stringify(data)
      }
    };
    socket.emit("send_video_message", message);
    //console.log(`*** ${this.props.auth.uid} sending message ***`);
    /* firebase.firestore().doc(`video_chats/${this.props.match.params.chatId}`)
        .update({
            message: {
                senderId: this.props.auth.uid,
                data: JSON.stringify(data),
            }
        }) */
  };

  call = () => {
    //console.log("CREATING OFFER");

    this.pc
      .createOffer({
        offerToReceiveAudio: 1,
        offerToReceiveVideo: 1
      })
      .then(offer => this.pc.setLocalDescription(offer))
      .then(() => this.sendMessage({ sdp: this.pc.localDescription }))
      .catch(error => {
        console.log("OFFER ERROR", error);
      });
  };

  alteraChat() {
    if (this.state.chatAberto == true) this.setState({ chatAberto: false });
    else this.setState({ chatAberto: true });
  }

  start = () => {
    navigator.mediaDevices
      .getUserMedia(mediaStreamConstraints)
      .then(this.gotLocalMediaStream)
      .catch(this.handleLocalMediaStreamError);
  };

  gotLocalMediaStream = mediaStream => {
    //this.setState({videoSrc:mediaStream});
    this.localVideoRef.srcObject = mediaStream;
    this.localStream = mediaStream;
    for (const track of this.localStream.getTracks()) {
      this.pc.addTrack(track, this.localStream);
    }
  };

  handleLocalMediaStreamError = error => {
    console.log("navigator.getUserMedia error: ", error);
  };

  render() {
    console.log("*** STATUS:  ", this.state.status, " ***");

    return (
      <div className="col-md-8 col-lg-9 tela-video-container">
        <div className="video">
          <video
            id="remote-video"
            autoPlay
            ref={remoteVideoRef => {
              this.remoteVideoRef = remoteVideoRef;
            }}
          ></video>
          <div className="video-chat-container">
            {/* <button className='chat-header'>
                            <p style={{marginBottom:'0'}} onClick={this.alteraChat}>
                                <FontAwesomeIcon icon={faCommentAlt} size='lg' color='#ffffff'/>&nbsp;Chat
                            </p>
                        </button> */}

            {/* this.state.chatAberto ? <div className='video-chat'>
                            <ListaMensagens/>
                            <InputChatVideo/>
                        </div> : null */}
          </div>
          {/* <GridButtons/> */}
          <video
            id="local-video"
            autoPlay
            muted
            ref={localVideoRef => {
              this.localVideoRef = localVideoRef;
            }}
          ></video>
          {/* <div className='contador' style={{textAlign:'center'}}>
                        <FontAwesomeIcon icon={faClock} />
                        <p>00:00</p>
                    </div> */}
        </div>
        {this.props.userId === this.state.professional._id &&
        this.state.status !== "canceled" ? (
          <Button className="call-btn" onClick={this.call}>
            {this.state.callString}
          </Button>
        ) : null}

        {this.props.userId === this.state.customer._id &&
        this.state.status !== "canceled" ? (
          <Button className="call-btn" onClick={() => this.onTerminateChat()}>
            {this.state.status === "requested" ||
            this.state.status === "waiting"
              ? "Cancelar chamada"
              : null}
            {this.state.status === "active" ? "Finalizar chamada" : null}
          </Button>
        ) : null}

        {this.state.status === "finished" ? (
          <div className="expired-modal">
            <h3>A videochamada foi encerrada!</h3>
          </div>
        ) : null}

        {this.state.status === "canceled" ? (
          <div className="expired-modal">
            <h3>A videochamada foi cancelada!</h3>
          </div>
        ) : null}

        {this.state.expiredModalOpen ? (
          <div className="expired-modal">
            <h3>Seus créditos expiraram!</h3>
            <Link to="/credit/checkout">
              Coloque mais créditos clicando aqui
            </Link>
          </div>
        ) : null}
      </div>
    );
  }
}

//export default TelaVideo;

const mapStateToProps = state => {
  return {
    userId: state.user.userInfo._id,
    token: state.user.userInfo.token
  };
};
export default connect(mapStateToProps)(withRouter(TelaVideo));
